import {escapeRegExp} from "./escapeRegExp";

export const getCookie = function (name) {
    const matches = document.cookie.match(new RegExp("(?:^|; )" + escapeRegExp(name) + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
};